import styled, { css } from "styled-components"

const StyledContactWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.color.secondary06};
  padding: 8rem ${({ theme }) => theme.layout.mobilePadding};
  min-height: 50rem;

  ${({ theme }) => theme.mq.medium} {
    padding: 9.6rem ${({ theme }) => theme.layout.mobilePadding} 7.2rem;
  }
`

const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mq.medium} {
    max-width: ${({ theme }) => theme.gridWidth};
    margin: 0 auto;
    justify-content: space-between;
    flex-direction: row;
  }
`
const StyledTextWrapper = styled.div`
  margin-bottom: 3.2rem;

  ${({ center }) =>
    center &&
    css`
      margin: 8.4rem auto 11.8rem;
      text-align: center;
    `}

  ${({ theme }) => theme.mq.medium} {
    max-width: 45.6rem;
  }
`
const textStyles = css`
  font-size: ${({ theme }) => theme.font.size.l};
  line-height: 1.78;
`

const titleStyles = css`
  margin: 4rem 0;
`

const StyledImageWrapper = styled.div`
  margin-top: 3.2rem;

  svg {
    width: 100%;
    height: 100%;
  }
`

export {
  StyledContactWrapper,
  StyledTextWrapper,
  textStyles,
  StyledFormWrapper,
  titleStyles,
  StyledImageWrapper,
}
